import React, { Component } from "react";
import config from './config';
import TextField from '@material-ui/core/TextField';
import { Link } from 'react-router-dom';
import { withRouter } from "react-router-dom";
class SearchForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: true,
            searchValue: this.props.searchValue === undefined ? '' : this.props.searchValue,
            searchCategories: this.props.searchCategories === undefined ? [] : this.props.searchCategories,
            selectedCategory: this.props.selectedCategory === undefined ? 0 : this.props.selectedCategory,
            isOnlineOfflineAllFilter: this.props.currentAdType === undefined ? 1 : this.props.currentAdType,
            localSearchOpen: !!this.props.searchFormToggle
        }

        if (this.props?.location?.state?.categoryId) {
          this.selectedCategory = parseInt(this.props?.location?.state?.categoryId);
        }

        console.log('this.selectedCategory',this.selectedCategory);

        this.handleSearchString = this.handleSearchString.bind(this);
        this.storeSearchString = this.storeSearchString.bind(this);
        this.searchOnCategory = this.searchOnCategory.bind(this);
        this.submitSearchForAllCat = this.submitSearchForAllCat.bind(this);
        this.updateOnlineOfflineStatus = this.updateOnlineOfflineStatus.bind(this);
        this.handleToggleClick = this.handleToggleClick.bind(this);
    }

    updateOnlineOfflineStatus(value) {
        var oldValue = this.state.isOnlineOfflineAllFilter;
        this.setState({ 'isOnlineOfflineAllFilter': value });
        if (oldValue !== value) {
            // if(value!==2){
            this.setState({ selectedCategory: 0 });
            // }
            this.props.updateOnlineOffLineStatus(value);
        }
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        if (prevProps.searchFormToggle !== this.props.searchFormToggle) {
            this.setState({ localSearchOpen: !!this.props.searchFormToggle });
        }
    }

    getPageViewTypeBasedOnCategory(Category) {
        var faOfflineCat = [66, 64, 67];
        return faOfflineCat.includes(Category) ? /* Offline */ 2 : /* Online */ 1;
    }

    searchOnCategory(newVal) {
        var feSearch = document.querySelector('input[name=firstName]');
        if (feSearch != undefined) {
            feSearch.value = '';
        }
        var isOnlineOfflineAllFilter = newVal === 0 ? this.state.isOnlineOfflineAllFilter : this.getPageViewTypeBasedOnCategory(newVal);
        this.setState({
            selectedCategory: newVal,
            isOnlineOfflineAllFilter: isOnlineOfflineAllFilter
        }, () => { this.handleSearchString('defaultSearch'); });
    }

    storeSearchString(event) {
        this.setState({
            searchValue: event.target.value
        });
    }

    submitSearchForAllCat(event) {
        event.preventDefault();
        // this.setState({ 'isOnlineOfflineAllFilter': 1 });
        var searchValue = this.state.searchValue;
        this.setState({ searchValue: '', selectedCategory: 0 });
        this.props.handleSearchAndCategory(searchValue, 0/*this.state.selectedCategory*/, this.state.isOnlineOfflineAllFilter);
    }

    handleSearchString(e) {
        this.props.handleSearchAndCategory(this.state.searchValue, this.state.selectedCategory, this.state.isOnlineOfflineAllFilter);
    }

    handleToggleClick() {
        if (typeof this.props.toggleSearchForm === 'function') {
            this.props.toggleSearchForm();
        } else {
            this.setState({ localSearchOpen: !this.state.localSearchOpen });
        }
    }

    render() {

        var categoryHtml = "";
        if (this.state.searchCategories.length > 0) {
            // Read flag from localStorage. If true/yes → show Option 2; else show Option 1
            var foGlobalSetting = JSON.parse(localStorage.getItem('foGlobalSetting')) || {};
            var fsShowSecondaryNabBarForShopify = (foGlobalSetting.fsShowSecondaryNabBarForShopify || '').toLowerCase();
            var isRewardsDomain = (window.location && window.location.hostname === 'rewards.mobyads.in' || window.location.hostname === 'mobyrewards.com');
            var showSecondaryMenu = ((fsShowSecondaryNabBarForShopify === 'yes') && isRewardsDomain);
            // var showSecondaryMenu = true;     

            if (showSecondaryMenu) {
                // Option 1 (original mapped categories)
                categoryHtml = <div className="searchCategoryRow secondary-menu top-menu-category-row"><div className="searchCategoryScroller">
                    <Link to="/map" className="singleCategory">
                        <span className="material-icons-outlined iconImage">room</span>
                        {/* <div className="category-name">Near By</div> */}
                    </Link>
                    <div id="category_70" className={"singleCategory free-gifts" + (this.state.selectedCategory === 70 ? ' flash-border-animation activeCat' : '')} key={70} onClick={() => this.searchOnCategory(70)}>
                        <div className="category-container">
                            <div className="category-text">Free Gifts <br/> Coupons</div>
                            <img src="https://mobyads.in/moby//images/category-images/1747468613-7938.jpg" />
                        </div>
                    </div>
                    <div id="category_54" className={"singleCategory casebank" + (this.state.selectedCategory === 68 ? ' flash-border-animation activeCat' : '')} key={68} onClick={() => this.searchOnCategory(68)}>
                        <div className="category-container">
                            <div className="category-text">Redeem <br/>Cashback</div>
                            <img src="https://mobyads.in/moby/images/category-images/1700812667-5374.png" />
                        </div>
                    </div>
                    {/* <div className="singleCategory" onClick={this.handleToggleClick}>
                        <span className="material-icons-outlined iconImage">
                            {(this.props.searchFormToggle || this.state.localSearchOpen) ? 'close' : 'search'}
                        </span>
                        <div className="category-name">{(this.props.searchFormToggle || this.state.localSearchOpen) ? 'Close' : 'Search'}</div>
                    </div> */}
                    <div id="category_0" className={"singleCategory Offline" + (this.state.selectedCategory === 67 ? ' flash-border-animation activeCat' : '')} key={67} onClick={() => this.searchOnCategory(67)}>
                        <div className="category-container">
                            <div className="category-text">Offline <br/>Voucher</div>
                            <img src="https://mobyads.in/moby/images/category-images/online-offer.jpg" />
                        </div>
                    </div>
                </div></div>
            } else {
                // Option 2 menu (reuse category row CSS)
                categoryHtml = <div className="searchCategoryRow opction-2"><div className="searchCategoryScroller">
                    {this.state.searchCategories.map((item, i) => {
                        var categoryClass = "singleCategory";
                        if (this.state.selectedCategory === item.fiCategoryId) {
                            categoryClass += ' activeCat';  
                        }
                        return (
                            <div key={i} onClick={() => this.searchOnCategory(item.fiCategoryId)} id={'category_' + item.fiCategoryId} className={categoryClass}>
                                {item.fsCategoryImage !== undefined ?
                                    <img src={config.getImageUrl(item.fsCategoryImage)} />
                                    : ''}
                                <div>{item.fsCategoryName}</div>
                            </div>
                        )
                    })}
                </div></div>
            }
        }

        var checkMark = <span className="material-icons-outlined check_circle">check_circle</span>

        var AppLogo = config.getProviderSetting().fsLogo
        return (
            <div className={"addListSearchFilter" + (this.props.isSearchScreen ? ' search-screen' : '')}>
                {config.isReferreFromExist() ?
                    <div className="branding-for-refferr-top-bar">
                        <div className="logo"><img alt="App Logo" src={AppLogo} /></div>
                        <div className="reward-store">Reward Store</div>
                        <div className="powered-by">
                            <div>Powered By</div>
                            <div>Moby</div>
                        </div>
                    </div> : ''}

                {this.props.isSearchScreen || this.props.searchFormToggle || this.state.localSearchOpen ?
                    <div className="searchForm">
                        <form onSubmit={this.submitSearchForAllCat}>
                            <div className="withLabel withIcon">
                                <div className="searchButton" onClick={this.submitSearchForAllCat}>
                                    <span className="material-icons-outlined">
                                        search
                                    </span>
                                    <span>Search</span>
                                </div>
                                <TextField type="search" defaultValue={this.state.searchValue} name="firstName" placeholder="Search brand here..." id="outlined-otp" variant="outlined" onChange={this.storeSearchString} autocomplete="off" />
                            </div>
                        </form>
                        <div className="onlineOfflineOfferFilter">
                            {/* <div className={this.state.isOnlineOfflineAllFilter===0?'active':''} onClick={()=>this.updateOnlineOfflineStatus(0)}>{this.state.isOnlineOfflineAllFilter===0?checkMark:''} All</div> */}
                            <div className={this.state.isOnlineOfflineAllFilter === 1 ? 'active' : ''} onClick={() => this.updateOnlineOfflineStatus(1)}> {this.state.isOnlineOfflineAllFilter === 1 ? checkMark : ''} Online Offers </div>
                            <div className={this.state.isOnlineOfflineAllFilter === 2 ? 'active' : ''} onClick={() => this.updateOnlineOfflineStatus(2)}> {this.state.isOnlineOfflineAllFilter === 2 ? checkMark : ''} Offline Offers</div>
                        </div>
                    </div> : ''}
                {categoryHtml}
            </div>
        )
    }
}

export default withRouter(SearchForm);